// React context + hook for the Ring App Store workspace (tenant) state.
//
// Distinct from `@/session` (which exposes `SessionMe` — alias + grants
// from `/api/session/me`). The workspace context exposes the active
// tenant resolution from the BFF `/api/session` endpoint and is consumed
// by appstore-specific surfaces (TenantPicker, TenantSettings, Locations,
// chrome indicators).

import { createContext, useContext } from "react";
import type { WorkspaceDescriptor } from "@/types/tenant";

export interface WorkspaceContextValue {
  workspace: WorkspaceDescriptor | null;
  loading: boolean;
  error: string | null;
  /** Set true when the BFF reports the tenant has been disconnected. */
  disconnected: boolean;
  refresh(): Promise<void>;
  markDisconnected(): void;
}

export const WorkspaceContext = createContext<WorkspaceContextValue | null>(
  null,
);

export function useWorkspace(): WorkspaceContextValue {
  const ctx = useContext(WorkspaceContext);
  if (!ctx) {
    throw new Error("useWorkspace must be used inside <WorkspaceProvider>");
  }
  return ctx;
}
